<template>
  <div>
    <!-- in viewBox 3rd argument is width 4th argument is height  -->
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 25 22"
      :fill="fill"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-rule="evenodd" :fill="fill" fill-rule="evenodd">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.67452 2.0001C7.2113 2.0001 7.3167 2.00653 7.40502 2.02773C7.50706 2.05223 7.6046 2.09263 7.69407 2.14746C7.77152 2.19492 7.85059 2.26491 8.23015 2.64447L9.35564 3.76995L9.4145 3.82889C9.70195 4.11688 9.95539 4.37079 10.2609 4.55802C10.5293 4.72251 10.822 4.84372 11.1281 4.91721C11.4765 5.00087 11.8353 5.00053 12.2422 5.00015L12.3255 5.0001H17.4C18.3966 5.0001 19.0839 5.00088 19.6174 5.04447C20.1392 5.0871 20.4251 5.16565 20.635 5.27259C21.1054 5.51227 21.4878 5.89472 21.7275 6.36513C21.813 6.53292 21.906 6.9586 21.9542 7.7401C21.9996 8.47505 22 9.36473 22 10.3544C22 10.9067 22.4477 11.3544 23 11.3544C23.5523 11.3544 24 10.9067 24 10.3544V10.3315C24 9.36882 24 8.41992 23.9504 7.61683C23.9033 6.8539 23.8055 6.03804 23.5095 5.45714C23.0781 4.61041 22.3897 3.922 21.543 3.49057C21.0041 3.21603 20.4257 3.10384 19.7802 3.05111C19.1557 3.00008 18.3864 3.00009 17.4421 3.0001L12.3255 3.0001C11.7887 3.0001 11.6833 2.99367 11.595 2.97247C11.4929 2.94798 11.3954 2.90757 11.3059 2.85274C11.2285 2.80528 11.1494 2.7353 10.7698 2.35574L9.64437 1.23025L9.58549 1.1713C9.29804 0.883321 9.04461 0.629415 8.73907 0.442181C8.47065 0.277695 8.17802 0.156482 7.87191 0.082992C7.52347 -0.000662141 7.16472 -0.000328357 6.75782 5.0252e-05L6.67452 0.00010175L6.55785 0.000101512C5.61355 9.03064e-05 4.84431 8.11256e-05 4.21978 0.0511075C3.5743 0.103845 2.99586 0.216033 2.45704 0.490572C1.61031 0.922003 0.921902 1.61041 0.490472 2.45714C0.215932 2.99596 0.103744 3.5744 0.0510067 4.21988C-1.92635e-05 4.8444 -1.04755e-05 5.61364 3.12433e-07 6.55793V6.55795V14.4423V14.4423C-1.04755e-05 15.3866 -1.92635e-05 16.1558 0.0510067 16.7803C0.103744 17.4258 0.215932 18.0042 0.490472 18.5431C0.921902 19.3898 1.61031 20.0782 2.45704 20.5096C2.99586 20.7842 3.5743 20.8964 4.21978 20.9491C4.8443 21.0001 5.61354 21.0001 6.55783 21.0001H13.3757C13.928 21.0001 14.3757 20.5524 14.3757 20.0001C14.3757 19.4478 13.928 19.0001 13.3757 19.0001H6.6C5.60341 19.0001 4.91611 18.9993 4.38264 18.9557C3.86085 18.9131 3.5749 18.8346 3.36502 18.7276C2.89462 18.4879 2.51217 18.1055 2.27248 17.6351C2.16555 17.4252 2.087 17.1393 2.04436 16.6175C2.00078 16.084 2 15.3967 2 14.4001V6.6001C2 5.60351 2.00078 4.91621 2.04436 4.38274C2.087 3.86095 2.16555 3.575 2.27248 3.36513C2.51217 2.89472 2.89462 2.51227 3.36502 2.27259C3.5749 2.16565 3.86085 2.0871 4.38264 2.04447C4.91611 2.00088 5.60341 2.0001 6.6 2.0001H6.67452ZM20.9933 12.8835C20.9355 12.3861 20.5128 12.0001 20 12.0001C19.4477 12.0001 19 12.4478 19 13.0001V16.0001H16L15.8834 16.0068C15.386 16.0646 15 16.4873 15 17.0001L15.0067 17.1167C15.0645 17.6141 15.4872 18.0001 16 18.0001H19V21.0001L19.0067 21.1167C19.0645 21.6141 19.4872 22.0001 20 22.0001C20.5523 22.0001 21 21.5524 21 21.0001V18.0001H24L24.1166 17.9934C24.614 17.9356 25 17.5129 25 17.0001L24.9933 16.8835C24.9355 16.3861 24.5128 16.0001 24 16.0001H21V13.0001L20.9933 12.8835Z"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'CreateFolderIcon',
  props: {
    svgColor: {
      type: String,
      default: '#000000',
    },
    svgHeight: {
      type: String,
      default: '24px',
    },
    svgWidth: {
      type: String,
      default: '24px',
    },
  },
  data() {
    return {
      fill: this.svgColor,
      width: this.svgWidth,
      height: this.svgHeight,
    };
  },
  methods: {
    setFill(value) {
      this.fill = value;
    },
  },
};
</script>
